var modules_a2a4272b = {"container":"_n24sc5","icon-sort":"_ytr1h","sort-asc":"_hq7xll","sort-desc":"_1bi11ym","fill":"_wvwkfn"};
import "../../../assets/Df_U8S2g.css";

export { modules_a2a4272b as default };
//# sourceMappingURL=Sorter.module.less.js.map
